<!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<template>
  <div :class="{'wizard-bubbles': bubbles }">
    <div class="wizard">
      <div class="wizard__progress-line" />
      <div
        class="wizard__progress-ready"
        :style="{ width: width }"
      />

      <div
        v-for="(value, index) of numberOfSteps"
        :key="value"
        class="wizard__inner d-flex flex-column"
      >
        <span
          class="wizard__step"
          :class="{
            'wizard__step--filled': index <= activeStep,
            'wizard__step--valid': index <= lastAvailableStep && index > activeStep,
            'wizard__step--error': errors.includes(labels[index]) || errors.includes(index)
          }"
          @click="changeStep(index)"
        >
          <template v-if="bubbles">
            <span
              v-if="index > activeStep"
              style="font-size:1.2em"
            >{{ index + 1 }}</span>
            <span
              v-else-if="index === activeStep"
              style="font-size:1.2em"
            >{{ index + 1 }}</span>
            <span v-else-if="errors.includes(labels[index]) || errors.includes(index)"><elIcon
              name="alert"
              size="xl"
            /></span>
            <span v-else-if="index <= activeStep"><elIcon
              name="check"
              size="xl"
            /></span>
          </template>
          <template v-else>
            {{ labels[index] }}
          </template>
        </span>
        <span
          v-if="bubbles"
          class="wizard__label"
        >{{ labels[index] }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import elIcon from './elIcon.vue'
const WIZARD_WIDTH = 80
const PADDING = 10

export default {
  components: {
    elIcon
  },
  props: {
    numberOfSteps: Number,
    activeStep: Number,
    lastAvailableStep: Number,
    labels: Array,
    errors: {
      type: Array,
      default: () => []
    },
    bubbles: Boolean
  },
  emits: ['update:activeStep'],
  computed: {
    width() {
      const padding = (this.activeStep === this.numberOfSteps - 1) ? PADDING * 2 : PADDING

      return `${padding + WIZARD_WIDTH / (this.numberOfSteps - 1) * this.activeStep}%`
    }
  },
  methods: {
    changeStep(step) {
      if (step > this.lastAvailableStep) return

      this.$emit('update:activeStep', step)
    }
  }
}
</script>

<style lang="scss">
@import "~@ui/styles/src/scss/utils/lib";

$wizardWidth: 80%;

.wizard {
  $stepWidth: 140px;

  @mixin progressBar {
  position: absolute;
  top: 50%;
  left: 0;
  height: 1px;
}

  @extend %flex-centered;

  position: relative;
  color: $secondaryGrey;

  &__progress-line {
    @include progressBar;

    z-index: 1;
    width: 100%;
    background-color: $secondaryGrey;
  }

  &__progress-ready {
    @include progressBar;

    z-index: 2;
    background-color: $primaryColor;
    transition: width 0.2s ease-out;
  }

  &__inner {
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: $wizardWidth;
  }

  &__step {
    min-width: $stepWidth;
    padding: 2px 20px;
    color: $primaryGrey;
    text-align: center;
    background-color: $secondaryGrey;
    border: 1px solid $secondaryGrey;
    border-radius: 15px;

    &--valid {
      background-color: #fff;
      border-color: $secondaryGrey;
      cursor: pointer;
    }

    &--filled {
      color: #fff;
      background-color: $primaryColor;
      border-color: $primaryColor;
      cursor: pointer;
      transition: all 0.1s ease-out 0.1s;
    }
  }
}

.wizard-bubbles {
  $stepWidthBubbles: 50px;

  @mixin progressBarBubbles {
    position: absolute;
    top: 40%;
    left: 0;
    height: 1px;
  }

  display: flex;

  .wizard {
    position: relative;
    width: 100%;
    color: $secondaryGrey;

    @extend %flex-centered;

    &__progress-line {
      @include progressBarBubbles;

      z-index: 1;
      width: 100%;
      background-color: $secondaryGrey;
    }

    &__progress-ready {
      @include progressBarBubbles;

      z-index: 2;
      background-color: $green-50;
      transition: width 0.2s ease-out;
    }

    &__inner {
      z-index: 3;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: $wizardWidth;
    }

    &__label {
      color: $grey-10 !important;
    }

    &__step {
      display: flex;
      align-items: center;
      justify-content: center;
      width: $stepWidthBubbles;
      min-width: $stepWidthBubbles;
      height: $stepWidthBubbles;
      color: $primaryGrey;
      text-align: center;
      background-color: $secondaryGrey;
      border: 1px solid $secondaryGrey;
      border-radius: 50%;

      &--valid {
        background-color: #fff;
        border-color: $secondaryGrey;
        cursor: pointer;
      }

      &--filled {
        color: #fff;
        background-color: $green-40;
        border-color: $green-40;
        cursor: pointer;
        transition: all 0.1s ease-out 0.1s;
      }

      &--error {
        color: #fff;
        background-color: $red-40;
        border-color: $red-50;
        cursor: pointer;
        transition: all 0.1s ease-out 0.1s;
      }
    }
  }
}

.bg-dark {
  .wizard__label {
    color: $grey-80 !important;
  }
}
</style>
